import { useEffect, useState } from "react";
import { getPreviewData } from "../api";
import { buildSampleData } from "../sample-data";

/*
 * Data the editor designs against. The backend loads a random existing
 * document of this type with the same function every print uses
 * (helper/printData.ts), so what you see while designing is what prints.
 * With no documents it sends placeholder values. If the backend cannot be
 * reached the built-in sample is used so the editor still works.
 */
export function usePreviewData(docType) {
  const [state, setState] = useState(() => ({ data: buildSampleData(docType), meta: { kind: "loading" } }));

  useEffect(() => {
    let alive = true;
    getPreviewData(docType)
      .then((res) => {
        if (!alive) return;
        if (res && res.data && typeof res.data === "object" && !Array.isArray(res.data)) setState({ data: res.data, meta: res.meta || { kind: "document" } });
        else setState({ data: buildSampleData(docType), meta: { kind: "offline" } });
      })
      .catch(() => alive && setState({ data: buildSampleData(docType), meta: { kind: "offline" } }));
    return () => {
      alive = false;
    };
  }, [docType]);

  return { sample: state.data, meta: state.meta };
}

export function describeSource(meta) {
  switch (meta?.kind) {
    case "document":
      return `document ${meta.number || meta.id}`;
    case "placeholder":
      return "placeholder data (no documents yet)";
    case "offline":
      return "built-in sample data (server not reachable)";
    default:
      return "sample data";
  }
}
